module.exports = __webpack_public_path__ + "static/media/glo-magento.23824f7c.png";